import { useState } from 'react';
import styled from 'styled-components';
import {
  Loading,
  Flex,
  FlexColumn,
  Breadcrumbs,
  Button,
  Table,
} from '@elementary/common-ui/components';
import { Typography } from '@mui/material';
import useGPGKeys from './hooks/useGPGKeys';
import useGPGKeysColumns from './hooks/useGPGKeysColumns';
import AddGPGKeyDialog from './components/AddGPGKeyDialog/AddGPGKeyDialog';

const Wrapper = styled(FlexColumn)`
  width: 100%;
  gap: 24px;
`;

const Frame = styled(FlexColumn)`
  border: 1px solid ${({ theme }) => theme.palette.common.gray8};
  border-radius: 6px;
  padding: 32px;
  gap: 24px;
`;

const GPGKeys = () => {
  const [isAddDialogOpen, setIsAddDialogOpen] = useState(false);

  const { gpgKeys, activeKey, isLoading } = useGPGKeys();
  const columns = useGPGKeysColumns();

  return isLoading ? (
    <Loading />
  ) : (
    <Wrapper>
      <Breadcrumbs items={['User', 'GPG Keys']} showTreeButton={false} />

      <Frame>
        <Flex sx={{ justifyContent: 'space-between' }}>
          <Typography sx={{ fontWeight: 'bold' }}>GPG Keys</Typography>
          <Button
            onClick={() => setIsAddDialogOpen(true)}
            disabled={!!activeKey}
          >
            Add GPG Key
          </Button>
        </Flex>

        <Table
          data={gpgKeys || []}
          columns={columns}
          isLoading={isLoading}
          urlParamsPrefix="gpg_keys_table"
        />

        <AddGPGKeyDialog
          isOpen={isAddDialogOpen}
          onClose={() => setIsAddDialogOpen(false)}
        />
      </Frame>
    </Wrapper>
  );
};

export default GPGKeys;
